/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource} from '@irian-ro/abstract-resource';
import {
  MasterRoutingSolutionDtoModel, MasterRoutingSolutionExtended,
  MasterRoutingSolutionsMetadataModel,
  MasterRoutingSolutionTrackingViewModel
} from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MasterRoutingSolutionResourceService extends AbstractResourceService<MasterRoutingSolutionDtoModel, MasterRoutingSolutionDtoModel, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('masterRoutingSolutionUrl'),
      MasterRoutingSolutionDtoModel,
      MasterRoutingSolutionDtoModel
    );
  }

  getMasterSolutionsForShipmentGroupSolution(shipmentGroupSolutionUuid: string)
    : Observable<JsonApiResource<MasterRoutingSolutionTrackingViewModel[], MasterRoutingSolutionsMetadataModel>> {
    return <Observable<JsonApiResource<MasterRoutingSolutionTrackingViewModel[], MasterRoutingSolutionsMetadataModel>> >this.httpClient?.get(`${this.url}/${shipmentGroupSolutionUuid}`);
  }

  setPreferred(uuid: string)
    : Observable<boolean> {
    return <Observable<boolean>>this.httpClient?.put(`${this.url}/preferred/${uuid}`, null);
  }

  getExtendedMasterRoutingSolutionsByShipmentGroup(shipmentGroupUuid: string)
    : Observable<JsonApiResource<MasterRoutingSolutionExtended[], JsonApiListResourceMetadataBase>> {
    return <Observable<JsonApiResource<MasterRoutingSolutionExtended[], JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/extended/${shipmentGroupUuid}`);
  }

}
